import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { Vulnerability } from 'api/vulnerabilities/type';
import { Breakpoints } from 'hooks/Screen/useScreenSize';
import VulStatusCell from 'components/ObjectVuls/VulStatusCell';
import LinkCell from 'components/TrapsTables/Cells/LinkCell/LinkCell';
import UserDataCell from 'components/ObjectVuls/UserDataCell';
import ActionCell from 'components/TrapsTables/Cells/ActionCell/ActionCell';

export const useGetObjectVulsColumns = (slug: string): TableColumn<Vulnerability>[] => {
  const { t } = useTranslation();

  return [
    {
      name: t('ObjectVuls.table.status'),
      selector: row => row.status.name,
      sortable: true,
      sortField: 'order_number',
      cell: row => <VulStatusCell status={row.status.name} placeholder={row.status.placeholder} />,
      width: '105px',
    },
    {
      name: t('ObjectVuls.table.map'),
      selector: row => row.floor_plan_slug,
      cell: row => (
        <LinkCell
          title={row.floor_plan_name}
          link={`/object/plan/vulnerability/${slug}/${row.floor_plan_slug}/${row.id}`}
          icon="ri-treasure-map-line"
        />
      ),
      grow: 2,
      hide: Breakpoints.Mobile,
    },
    {
      name: t('ObjectVuls.table.category'),
      selector: row => row.category,
      cell: row => t(`ObjectVuls.categories.${row.category}`, { defaultValue: row.category }),
      sortable: true,
      sortField: 'category',
      grow: 2,
      minWidth: '150px',
      hide: Breakpoints.Tablet,
    },
    {
      name: t('ObjectVuls.table.criticality'),
      selector: row => row.criticality,
      cell: row => t(`ObjectVuls.criticality.${row.criticality}`, { defaultValue: row.criticality }),
      sortable: true,
      sortField: 'criticality',
      grow: 2,
      hide: Breakpoints.Mobile,
    },
    {
      name: t('ObjectVuls.table.instpector'),
      selector: row => row.inspector_data.name,
      cell: row => <UserDataCell user={row.inspector_data} />,
      grow: 2,
      hide: Breakpoints.Desktop,
    },
    {
      name: t('ObjectVuls.table.responsible'),
      selector: row => row.responsible_data.name,
      cell: row => <UserDataCell user={row.responsible_data} />,
      sortable: true,
      hide: Breakpoints.Desktop,
    },
    {
      name: t('ObjectVuls.table.createDate'),
      selector: row => row.create_date,
      cell: row => dayjs(row.create_date).format('DD-MM-YYYY'),
      sortField: 'create_date',
      sortable: true,
      hide: Breakpoints.Tablet,
    },
    {
      name: t('ObjectVuls.table.lastDate'),
      selector: row => row.last_date,
      cell: row => dayjs(row.last_date).format('DD-MM-YYYY'),
      sortField: 'last_date',
      sortable: true,
    },
    {
      name: t('ObjectVuls.table.resolutionDate'),
      selector: row => row?.fix_date || '-',
      cell: row => (row?.fix_date ? dayjs(row.fix_date).format('DD-MM-YYYY') : '-'),
      sortField: 'resolution_date',
      sortable: true,
    },
    {
      name: t('ObjectVuls.table.action'),
      cell: row => (
        <ActionCell trap={{ pk: row.id, serialNumber: '' }} slug={slug} eyes isVul comment vulnerability={row} />
      ),
      sortable: true,
      sortField: 'Action',
      hide: Breakpoints.Desktop,
    },
  ];
};
